import Alpine from 'alpinejs'
import persist from '@alpinejs/persist'
import intersect from '@alpinejs/intersect'
import Swiper, { Pagination, EffectFade, Autoplay, Thumbs, Navigation } from 'swiper'
import 'swiper/css'

import 'swiper/css/pagination'
import 'swiper/css/effect-fade'
import 'swiper/css/thumbs'

import { gsap } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import collapse from '@alpinejs/collapse'

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)
// Product page custom cursor

window.addEventListener('load', () => {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`)
})

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
})

function customCursor() {
  var cursor = document.querySelector('.js-cursor')
  var closeCursor = document.querySelector('.close-modal--button')
  var mediaCarousel = document.querySelector('#media-wrapper')

  document.addEventListener('mousemove', (t) => {
    if (
      t.target === mediaCarousel ||
      t.target.matches('.custom-cursor-image')
    ) {
      if (t.target.classList.contains('lg:!flex')) {
        return
      } else {
        cursor.classList.add('lg:!flex')
      }
    }

    // let cursorDot = document.querySelector('[data-dot]')

    var curX = t.clientX
    var curY = t.clientY

    closeCursor.style.transform =
      'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%))'

    cursor.style.transform =
      'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%))'
  })

  mediaCarousel.addEventListener('mouseleave', () => {
    cursor.classList.remove('lg:!flex')
  })
}

// Sorting options

const showSortingOptions = () => {
  let input = document.querySelector('#sort-options-wrapper')
  let itemsToShow = document.querySelector('#sort-by')
  let chevron = document.querySelector('.sort-chevron')

  gsap.to(chevron, {
    rotate: '180',
    ease: 'power2.in',
    duration: 0.2
  })

  let timeline = gsap.timeline()

  timeline
    .to(input, {
      borderBottomColor: 'rgba(0, 0, 0, 0.01)',
      ease: 'power2.in',
      duration: 0.2
    })
    .to(input, {
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
      duration: 0.2,
      ease: 'power2.in'
    })
    .to(itemsToShow, {
      opacity: 1,
      height: 'auto',
      duration: 0.4,
      ease: 'power2.in'
    })

  console.log('toggle test play')
}

const hideSortingOptions = () => {
  let input = document.querySelector('#sort-options-wrapper')
  let itemsToShow = document.querySelector('#sort-by')

  let chevron = document.querySelector('.sort-chevron')

  gsap.to(chevron, {
    rotate: '0',
    ease: 'power2.in',
    duration: 0.2
  })

  let timeline = gsap.timeline()

  timeline
    .to(itemsToShow, {
      height: 0,
      opacity: 0,
      delay: 0.1,
      ease: 'power2.in',
      duration: 0.2
    })
    .to(input, {
      borderBottomRightRadius: '20px',
      borderBottomLeftRadius: '20px',
      borderBottomColor: 'rgba(9, 35, 36, 0.2)',
      ease: 'power2.in',
      duration: 0.03
    })

  console.log('toggle test')
}

// Header Menu

const showMenu = (e) => {
  e.preventDefault()

  let count = e.target.dataset.count * 1

  console.log(count)

  // Select header and closer

  const siteHeader = document.querySelector('#site-layout-header')
  const headerDrawerCloser = document.querySelector(
    '#header-menus-transparent--close'
  )

  siteHeader.classList.add('!bg-green')

  // disable scroll

  const docBody = document.querySelector('body')

  docBody.classList.add('overflow-hidden', 'menu-drawer-open')

  // hovered element

  const hoveredElement = e.target

  // Menu to select

  const thisMenu = e.target.dataset.link
  const thisMenuSelected = document.querySelector(`[data-menu="${thisMenu}"]`)

  // All menus revert back to intended style before showing active menu

  const allMenus = document.querySelectorAll('.dropdown-menu--wrapper')
  const allLinks = document.querySelectorAll('.parent-link')
  const headerDrawer = document.querySelector('#header-menus-drawer')

  if (count > 4) {
    gsap.to(headerDrawer, {
      height: 'auto',
      duration: 0.1,
      ease: 'power2.in'
    })
  } else {
    gsap.to(headerDrawer, {
      height: 'auto',
      duration: 0.1,
      ease: 'power2.in'
    })
  }

  allLinks.forEach((element) => {
    element.classList.remove('active')
  })

  hoveredElement.classList.add('active')

  let tl = gsap.timeline({
    onStart: () => {
      for (let index = 0; index < allMenus.length; index++) {
        const element = allMenus[index]

        element.style.display = 'none'
        element.style.opacity = 0
      }
    }
  })

  tl.set(headerDrawer, {
    display: 'grid'
  })

  tl.to(headerDrawer, {
    y: 0,
    duration: 0.2
  })

  tl.set(headerDrawerCloser, {
    display: 'block'
  })

  tl.to(thisMenuSelected, {
    display: 'block',
    opacity: 1,
    duration: 0.2,
    delay: 0.1
  })

  console.log(thisMenu)
}

// Mobile Menu

const showMenuMobile = (e) => {
  e.preventDefault()

  // Select header and closer

  const siteHeader = document.querySelector('#site-layout-header')
  const headerDrawerCloser = document.querySelector(
    '#header-menus-transparent--close'
  )

  siteHeader.classList.add('!bg-green')

  // disable scroll

  const docBody = document.querySelector('body')
  docBody.classList.add('overflow-hidden')

  // hovered element

  const hoveredElement = e.target

  // Menu to select

  const thisMenu = e.target.dataset.link
  const thisMenuSelected = document.querySelector(
    `[data-menu-mobile="${thisMenu}"]`
  )

  // All menus revert back to intended style before showing active menu

  const allMenus = document.querySelectorAll('.dropdown-menu--wrapper-mobile')
  const headerDrawer = document.querySelector('#header-menus-drawer-mobile')

  hoveredElement.classList.add('active')

  let tl = gsap.timeline({
    onStart: () => {
      for (let index = 0; index < allMenus.length; index++) {
        const element = allMenus[index]

        element.style.display = 'none'
        element.style.opacity = 0
      }
    }
  })

  tl.set(headerDrawer, {
    display: 'grid'
  })

  tl.to(headerDrawer, {
    x: 0,
    duration: 0.2
  })

  tl.set(headerDrawerCloser, {
    display: 'block'
  })

  tl.to(thisMenuSelected, {
    display: 'block',
    opacity: 1,
    duration: 0.2
  })
}

const closeMenu = () => {
  const siteHeader = document.querySelector('#site-layout-header')

  const allMenus = document.querySelectorAll('.dropdown-menu--wrapper')
  const headerDrawer = document.querySelector('#header-menus-drawer')

  const headerDrawerCloser = document.querySelector(
    '#header-menus-transparent--close'
  )

  for (let index = 0; index < allMenus.length; index++) {
    const element = allMenus[index]

    element.style.display = 'none'
    element.style.opacity = 0
  }

  let tl = gsap.timeline({
    onStart: () => {
      siteHeader.classList.remove('!bg-green')

      for (let index = 0; index < allMenus.length; index++) {
        const element = allMenus[index]

        element.style.display = 'none'
        element.style.opacity = 0
      }
    },
    onComplete: () => {
      // enable scroll

      const docBody = document.querySelector('body')
      docBody.classList.remove('overflow-hidden', 'menu-drawer-open')
    }
  })

  tl.to(headerDrawer, {
    y: '-100%',
    duration: 0.3
  })

  tl.to(headerDrawer, {
    display: 'none',
    delay: 0.3
  })

  tl.set(headerDrawerCloser, {
    display: 'none'
  })
}

const closeMenuMobile = (e) => {
  e.preventDefault()

  // Select header and closer

  const siteHeader = document.querySelector('#site-layout-header')

  siteHeader.classList.add('!bg-green')

  // disable scroll

  const docBody = document.querySelector('body')
  docBody.classList.add('overflow-hidden')

  // hovered element

  const hoveredElement = e.target

  // Menu to select

  const thisMenu = e.target.dataset.link
  const thisMenuSelected = document.querySelector(
    `[data-menu-mobile="${thisMenu}"]`
  )

  // All menus revert back to intended style before showing active menu

  const allMenus = document.querySelectorAll('.dropdown-menu--wrapper-mobile')
  const headerDrawer = document.querySelector('#header-menus-drawer-mobile')

  hoveredElement.classList.add('active')

  let tl = gsap.timeline({
    onComplete: () => {
      for (let index = 0; index < allMenus.length; index++) {
        const element = allMenus[index]

        element.style.display = 'none'
        element.style.opacity = 0
      }

      const docBody = document.querySelector('body')
      docBody.classList.remove('overflow-hidden')
    }
  })

  tl.to(headerDrawer, {
    x: 0,
    duration: 0.2
  })

  tl.set(headerDrawer, {
    display: 'none'
  })

  tl.to(thisMenuSelected, {
    display: 'none',
    opacity: 0,
    duration: 0.2
  })
}

// Header Search bar

const openSearchDrawer = (e) => {
  console.log(e)

  // Use GSAP to transition header correctly

  /* Selectors */

  // Button

  const button = e.target

  // Headers

  const siteHeader = document.querySelector('#site-layout-header')

  // Search bar

  const searchBar = document.querySelector('#header-search-bar')

  /* Get Height settings */

  const rect = siteHeader.getBoundingClientRect()
  const offset = {
    top: rect.top + window.scrollY,
    bottom: rect.bottom - window.innerHeight,
    left: rect.left + window.scrollX
  }
  const width = siteHeader.offsetWidth
  const height = siteHeader.offsetHeight
  const bottom = offset.bottom
  const top = offset.top - window.pageYOffset
  const left = offset.left

  /* animate */

  var tlOpen = gsap.timeline()

  tlOpen.set(searchBar, {
    height: height
  })

  tlOpen.to(siteHeader, {
    opacity: 0,
    duration: 0.2
  })

  tlOpen.to(siteHeader, {
    translateY: '-100%',
    duration: 0.2
  })

  tlOpen.to(searchBar, {
    translateY: 0,
    duration: 0.1
  })
}

//  Close search bar

const closeSearchDrawer = (e) => {
  // Use GSAP to transition header correctly

  /* Selectors */

  // Button

  const button = e.target

  // Headers

  const siteHeader = document.querySelector('#site-layout-header')

  // Search bar

  const searchBar = document.querySelector('#header-search-bar')

  /* Get Height settings */

  const rect = siteHeader.getBoundingClientRect()
  const offset = {
    top: rect.top + window.scrollY,
    bottom: rect.bottom - window.innerHeight,
    left: rect.left + window.scrollX
  }
  const width = siteHeader.offsetWidth
  const height = siteHeader.offsetHeight
  const bottom = offset.bottom
  const top = offset.top - window.pageYOffset
  const left = offset.left

  /* animate */

  var tlClose = gsap.timeline()

  tlClose.to(searchBar, {
    translateY: '-100%',
    duration: 0.2
  })

  tlClose.set(siteHeader, {
    opacity: 1,
    duration: 0.2
  })

  tlClose.to(siteHeader, {
    translateY: 0,
    duration: 0.2
  })
}

// Home Page Slider

Alpine.data('heroSlider', () => ({
  init() {
    let slideTime = this.$el.getAttribute('data-slide-time')
    let transitionSpeed = this.$el.getAttribute('data-transition-speed')

    const swiper = new Swiper(this.$el.querySelector('.swiper'), {
      modules: [Pagination, Autoplay],
      slidesPerView: 1,
      autoplay: {
        enabled: true,
        delay: slideTime
      },
      speed: transitionSpeed,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    })
    swiper.on('slideChange', function (sl) {
      // const slides = sl.slides
      // const activeSlide = slides[sl.activeIndex]
      // const caption = activeSlide.dataset.caption
      // const section = activeSlide.dataset.section
      // const captionToUpdate = document.querySelector(`#image-caption-${section}`)
      // if(caption.length > 0 && caption.length !== null) {
      //     captionToUpdate.innerHTML = caption
      // }
    })
  }
}))

// Product Thumbnails
Alpine.data('productMedia', () => ({
  activeMainImageIndex: 0,
  detailHeight: 0,

  init() {
    let mm = gsap.matchMedia();

    mm.add("(min-width: 1024px)", () => {
      this.detailsHeight = this.$el.querySelector('.details-inner').offsetHeight;
      
      let thumbsHeight = this.$refs.thumbnails.children.length * 90;
      let headerHeight = document.querySelector('header').offsetHeight + 20;
      let thumbScrollHeight = this.$refs.main.offsetHeight - thumbsHeight - 20;

      ScrollTrigger.create({
          trigger: this.$refs.thumbnails,
          start: `top top+=${headerHeight}px`,
          end: `+=${thumbScrollHeight}px`,
          pin: true,
          scrub: 1,
          anticipatePin: 1,
          pinSpacing: false
      });

      const innerElement = document.querySelector('.details-inner');
      const containerElement = document.querySelector('.details-main');

      function updateEndValue() {
        return containerElement.offsetHeight - innerElement.offsetHeight - 50;
      }

      let detailTrigger = ScrollTrigger.create({
          trigger: innerElement,
          start: `top top+=${headerHeight}px`,
          end: () => `+=${updateEndValue()}`,
          pin: true,
          onUpdate: (self) => {
              self.end = self.start + updateEndValue();
              self.refresh();
          }
      });

      this.$watch('detailHeight', (value) => {
        updateEndValue();
        detailTrigger.refresh();
      });
    });
  },

  updateDetailHeight() {
    console.log('hellox')
    this.detailHeight = this.$el.querySelector('.details-inner').offsetHeight;
  },

  scrollToImage(index) {
    let headerHeight = document.querySelector('header').offsetHeight + 20;
    let targetImage = document.querySelector('#media-wrapper').children[index];

    gsap.to(window, { duration: 1, scrollTo: { y: targetImage, offsetY: headerHeight } });
  },

  handleIntersection(index) {
    this.activeMainImageIndex = index;
  }
}))

// Categories Slider

Alpine.data('categorieslider', () => ({
  init(element) {
    const swiper = new Swiper(element, {
      modules: [Pagination, Autoplay],
      slidesPerView: 1.2,
      autoHeight: true,
      spaceBetween: 20,
      autoplay: {
        delay: 3000
      },
      pagination: {
        el: '.swiper-pagination-categories',
        clickable: true
      },
      breakpoints: {
        320: {
          slidesPerView: 1.2
        },
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 3
        }
      }
    })
    swiper.on('activeIndexChange', (sl) => {
      let slideIndex =
        sl.activeIndex === 0 ? sl.activeIndex + 1 : sl.activeIndex - 1

      let indexDisplay = document.querySelector('.number')

      indexDisplay.innerHTML = `${slideIndex} `
    })
    ;(function () {
      const parent = document.querySelector('.wrapper-section--swiper')

      let totalPagination = swiper.pagination.bullets.length

      let totalDisplayElement = parent.querySelector('.total')

      totalDisplayElement.innerHTML = '2'
    })()
  }
}))

Alpine.data('collectionListingSlider', () => ({
  init(element) {
    const swiper = new Swiper(element, {
      modules: [Pagination, Autoplay],
      slidesPerView: 1,
      autoHeight: true,
      spaceBetween: 20,
      autoplay: {
        delay: 3000
      },
      pagination: {
        el: '.swiper-pagination-collection-listing',
        clickable: true
      }
    })
  }
}))

// Home Page Slider

Alpine.data('featuredBlockSlider', () => ({
  init(element) {
    const swiperBlock = new Swiper(element, {
      modules: [Pagination, EffectFade, Autoplay],
      slidesPerView: 1,
      spaceBetween: 0,
      slidesPerView: 1,
      effect: 'fade',
      autoplay: {
        delay: 3000
      },
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.swiper-pagination-block',
        clickable: true
      }
    })
    swiperBlock.on('activeIndexChange', (sl) => {
      let slideIndex = sl.activeIndex + 1

      let indexDisplay = document.querySelector('.number-block')

      indexDisplay.innerHTML = `${slideIndex} `
    })
    ;(function () {
      const parent = document.querySelector('.wrapper-section--swiper-block')

      let totalPagination = swiperBlock.pagination.bullets.length

      let totalDisplayElement = parent.querySelector('.total-block')

      totalDisplayElement.innerHTML = '3'
    })()
  }
}))

Alpine.data('ticker', () => ({
    init(){
        // let widestElement = 0;

        // this.$el.querySelectorAll('li').forEach((element) => {
        //     if (element.offsetWidth > widestElement) {
        //         widestElement = element.offsetWidth;
        //     }
        // });

        gsap.to(this.$el.querySelectorAll('ul'), {
            duration: 15,
            repeat: -1,
            ease: "none",
            x: `-100%`,
        });
    }
}));

// Home Page Slider

Alpine.data('productImageMobileSlider', () => ({
  init(element) {

    const thumbsSwiper = new Swiper(this.$refs.thumbs.querySelector('.swiper'), {
      modules: [Navigation],
      slidesPerView: 3,
      loopAdditionalSlides: 3,
      spaceBetween: 5,
      loop: true,
      // centeredSlides: true,
      navigation: {
        nextEl: this.$refs.thumbs.querySelector('.button-next'),
        prevEl: this.$refs.thumbs.querySelector('.button-prev')
      }
    })

    new Swiper(this.$refs.mains, {
      modules: [Thumbs],
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      thumbs: {
        swiper: thumbsSwiper
      }
    })
  }
}))

Alpine.data('designerHeroMobileSlider', () => ({
  init() {
    const swiper = new Swiper(this.$el, {
      modules: [Pagination, Autoplay],
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 3000
      },
      pagination: {
        el: this.$el.querySelector('.swiper-pagination'),
        clickable: true
      }
    })
  }
}))

Alpine.data('designerCollageMobileSlider', () => ({
  init() {
    const swiper = new Swiper(this.$el, {
      modules: [Pagination, Autoplay],
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 3000
      },
      pagination: {
        el: this.$el.querySelector('.swiper-pagination'),
        clickable: true
      }
    })
  } 
}))

Alpine.data('alternatingImagesTextMobileSlider', () => ({
  activeIndex: 0,
  init() {
    const swiper = new Swiper(this.$el.querySelector('.swiper'), {
      modules: [Pagination, Autoplay],
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: this.$el.querySelector('.swiper-pagination'),
        clickable: true
      },
      on: {
        init: (swiper) => {
          let newHeight = this.$refs.infoContainer.children[swiper.realIndex].getBoundingClientRect().height;

          gsap.to(this.$refs.infoContainer, {
            height: newHeight,
            duration: 0
          });

          this.activeIndex = swiper.realIndex;
        },
        slideChangeTransitionEnd: (swiper) => {

          let newHeight = this.$refs.infoContainer.children[swiper.realIndex].getBoundingClientRect().height;

          gsap.to(this.$refs.infoContainer, {
            height: newHeight,
            duration: 0.5,
            ease: 'power2.out'
          });

          this.activeIndex = swiper.realIndex;
        }
      }
    })
  }
}))


Alpine.data('expandingDescription', () => ({
  expanded: false,
  
  init() {

  }
}))

Alpine.data('eventsListing', () => ({
  events: [],
  pageInfo: null,
  loading: true,
  
  async init() {
    await this.fetchEvents();
  },
  
  async fetchEvents(cursor = null) {
    const query = `
      query Events($cursor: String) {
        products(
          first: 20,
          after: $cursor,
          query: \"product_type:ticket\"
        ) {
          edges {
            node {
              id
              title
              description
              onlineStoreUrl
              featuredImage {
                url(transform: { maxWidth: 400 })
                altText
              }
              metafield(namespace: "custom", key: "event_time_and_date") {
                value
              }
            }
            cursor
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    `;

    try {
      const response = await fetch('/api/2025-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': 'e441195ea228e7becd0880305bd9dd29'
        },
        body: JSON.stringify({
          query,
          variables: { cursor }
        })
      });

      const data = await response.json();

      console.log(data)

      this.events = data.data.products.edges;
      this.pageInfo = data.data.products.pageInfo;
      this.loading = false;
    } catch (error) {
      console.error('Error fetching events:', error);
      this.loading = false;
    }
  },
  
  async nextPage() {
    if (this.pageInfo?.hasNextPage) {
      this.loading = true;
      await this.fetchEvents(this.pageInfo.endCursor);
    }
  },
  
  async prevPage() {
    if (this.pageInfo?.hasPreviousPage) {
      this.loading = true;
      await this.fetchEvents(this.pageInfo.startCursor);
    }
  }
}))

// Load more button pagination

window.showSortingOptions = showSortingOptions
window.hideSortingOptions = hideSortingOptions
window.customCursor = customCursor
window.closeSearchDrawer = closeSearchDrawer
window.closeMenuMobile = closeMenuMobile
window.showMenuMobile = showMenuMobile
window.closeMenu = closeMenu
window.showMenu = showMenu
window.openSearchDrawer = openSearchDrawer
window.Alpine = Alpine
Alpine.plugin(persist)
Alpine.plugin(collapse)
Alpine.plugin(intersect)

Alpine.start()

let Sunrise = {
  updateQuantity(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ quantity: qty, line: line })
    })
      .then((response) => response.json())
      .then((data) => {
        if(data?.status == 422) {
          window.dispatchEvent(new CustomEvent('cart-error-updated', {
            detail: 'Due to stock availability, you\'re unable to add more items to the cart.'
          }))
        } else {
          // fire javascript event on window
          window.dispatchEvent(new Event('cart-updated'))
        }
        
      })
      .catch((error) => {
        console.error('Error:', error)
      })
  }
}

window.Sunrise = Sunrise
